import React from 'react'
import PropTypes from 'prop-types'
import { MailIcon } from 'images'

// Gmail promotions-tab chrome: hamburger + avatar header row, an ad creative
// image, an "Ad · {businessName} ↗" sender row, headline, and a few fake
// inbox rows below (Figma node 31518:16487 desktop-video — see
// googleDisplayVariations.js).
const GmailChromeCard = ({ ad }) => {
  const { headline, businessName, media } = ad
  const isVideo = media?.type === 'video' || (media?.url && media.url.endsWith('.mp4'))

  return (
    <div className="google-display-card google-display-card--gmail">
      <div className="google-display-card__gmail-header">
        <span className="google-display-card__hamburger">
          <span />
          <span />
          <span />
        </span>

        <span className="google-display-card__avatar" />
      </div>

      <div className='rectangle'/>

      <div className='ad-info'>
        {isVideo ? (
          <video className="google-display-card__gmail-media" src={media.url} autoPlay loop muted playsInline />
        ) : (
          <img className="google-display-card__gmail-media" src={media?.url} alt={media?.filename || 'ad creative'} />
        )}

        <div className='google-display-card__gmail-text'>
          <div className='google-display-card__gmail-business-name'>
            <span>Ad</span>

            <span style={{ fontWeight: '800' }}>·</span>

            <span className='business-name'>{businessName || 'Business Name'} ↗</span>
          </div>

          <p className='headline'>{headline}</p>
        </div>
      </div>

      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className='google-display-card__gmail-inbox-container'>
          <div className='avatar' />
          
          <div className="google-display-card__gmail-inbox">
            <div className="google-display-card__gmail-row" />
            <div className="google-display-card__gmail-row" />
            <div className="google-display-card__gmail-row" />
          </div>
        </div>
      ))}

      <div className='google-display-card__gmail-footer'>
        <div className='google-display-card__gmail-icon-item'>
          <MailIcon width={20} height={20} />
        </div>

        <div className='google-display-card__gmail-item'/>

        <div className='google-display-card__gmail-item'/>
      </div>
    </div>
  )
}

GmailChromeCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    businessName: PropTypes.string,
    media: PropTypes.object,
  }).isRequired,
}

export default GmailChromeCard
